export class MultiVendorSkuRequestDto {
    public readonly primarySku: string;
    public readonly alternateSku1: string | null;
    public readonly alternateSku2: string | null;

    constructor(primarySku: string,
                alternateSku1: string,
                alternateSku2: string | null) {
        this.primarySku = primarySku;
        this.alternateSku1 = alternateSku1;
        this.alternateSku2 = alternateSku2;
    }
}
